import React, { Fragment, useEffect, useContext } from "react";
import { TextsContext } from "context/textsContext";
import styleForm from '../../../scss/form.module.scss';
import ValidaComponent, { APPLICATION } from "../../../components/ValidaComponent";
import { SelectAppComponent } from "../../../components/application/SelectAppComponent";
import Stylegeneral from '../../../scss/general.module.scss'
import { InputTextComponent } from "../../../components/application/InputTextComponent";
import { useLocation } from "react-router-dom";
import { CheckboxComponent } from "components/CheckboxComponent";

const Registro6Page = () => {
    const { texts, verifyCurrentLanguage } = useContext(TextsContext);
    const {pathname} = useLocation();

    useEffect(() => {
		verifyCurrentLanguage();
	}, []);

    return (
        <Fragment>
            <section>
                <div className="container py-3">
                    <div className={`${styleForm.btn_activar}`}>
                        <label htmlFor="examenpediatrico" className={`${styleForm.labels} ${styleForm.sin_tootip} raleway  mb-2 color_primary_2 fw_700`}>
                            {texts?.page_six_checkbox_one ?? '¿Alguno de los solicitantes ha tenido consultas médicas en los últimos 9 meses? En caso afirmativo, indique:'}
                        </label>
                        <div className={`form-check form-switch input-personalizado ${styleForm.col_input}`}>
                            <CheckboxComponent className="form-check-input" type="checkbox" id="examenpediatrico" section={"/coberturaprevia"} name={"have9monthExam"} />
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container ">
                    <div className="row gy-4">
                        <div className={`col-12 ${Stylegeneral.colform}`}>
                            <SelectAppComponent
                                name="solicitante"
                                label={texts?.general_form_field_applicant ?? "Solicitante"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                placeholder='Ej:Colombia'
                                type='text'
                                options={[]}
                                section={pathname}
                            />

                            <ValidaComponent phase={APPLICATION} section={pathname} keyName={"solicitante"} />
                        </div>

                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="tconsulta"
                                label={texts?.page_six_form_field_query ?? "Tipo de consulta"}
                                placeholder={texts?.page_six_form_placeholder_query ?? "Ej: Examen general"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                type='text'
                            />
                            <ValidaComponent keyName={"tconsulta"} phase={APPLICATION} section={pathname} />
                        </div>

                        <div className={`col-12 ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.btn_activar}`}>
                                <label htmlFor="Rexamen" className={`${styleForm.labels} ${styleForm.sin_tootip} raleway  mb-2 color_primary_2 fw_700`}>
                                    {texts?.page_six_checkbox_two ?? '¿Se realizaron exámenes como consecuencia de esta consulta? En caso afirmativo, detallar cuáles fueron los exámenes:'}
                                </label>
                                <div className={`form-check form-switch input-personalizado ${styleForm.col_input}`}>
                                    <input className="form-check-input" type="checkbox" id="Rexamen" name={"addDependant"} />
                                </div>
                            </div>
                        </div>

                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="rexamen"
                                label={texts?.page_six_form_field_result ?? "Resultado de los exámenes"}
                                placeholder={texts?.page_six_form_placeholder_result ?? "Ej: Resultado de los exámenes"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                type='text'
                            />
                            <ValidaComponent keyName={"rexamen"} phase={APPLICATION} section={pathname} />
                        </div>


                    </div>
                </div>
            </section>
        </Fragment>
    )
}
export default Registro6Page;